import { io } from "socket.io-client";
import { getBackendUrl } from "../config";

let socket = null;

const buildSocketOptions = () => ({
  path: "/socket.io/",
  // Preferir websocket reduz 400 no polling (sid inválido / proxy sem sticky).
  transports: ["websocket", "polling"],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 15,
  reconnectionDelay: 1000,
  timeout: 20000,
  autoConnect: true,
});

/**
 * Conexão Socket.IO única (singleton) para o frontend.
 * Evita dezenas de conexões polling concorrentes e 400 "Session ID unknown" no close.
 */
export const getSocket = () => {
  const backendUrl = String(getBackendUrl() || "").replace(/\/$/, "");
  if (!backendUrl) {
    throw new Error("REACT_APP_BACKEND_URL não configurada.");
  }

  if (!socket) {
    socket = io(backendUrl, buildSocketOptions());
  }

  return socket;
};

/** Compatível com imports antigos: openSocket() / openSocket(url) */
function openSocket(url) {
  if (url) {
    const normalized = String(url).replace(/\/$/, "");
    const current = socket?.io?.uri;
    if (socket && current && !String(current).startsWith(normalized)) {
      socket.disconnect();
      socket = null;
    }
  }
  return getSocket();
}

export default openSocket;
